(function () {
    "use strict";

    angular
        .module("app")
        .component("orders", { // orders
            templateUrl: "src/app/orders/orders.html",
            controller: controller
        });

    /**
     * @param {ng.IScope} $scope
     * @param {ng.IQService} $q
     * @param {ng.IFilterService} $filter
     * @param {any} orders
     * @param {any} lookups
     * @param {any} session
     * @param {any} toast
     */
    function controller($window, $location, $scope, $q, $filter, $analytics, orders, lookups, session, toast) {
        const $ctrl = this;
        $ctrl.ui = {
            busy: {
                addresses: false,
                products: false,
                search: false
            }
        };

        // orders service
        $ctrl.orders = orders;

        // customer dropdown
        $ctrl.customerSelected = customer => {
            if ($ctrl.selectedCustomer === customer) return $q.resolve();

            $ctrl.selectedCustomer = customer;
            $ctrl.orders.searchCriteria.customer_id = customer ? customer.customer_id : null;
            $ctrl.orders.searchCriteria.company_name = customer ? customer.company_name : null;
            return $q.all([
                loadAddressesForSelectedCustomer(),
                loadProductsForSelectedCustomer()
            ]);
        };

        // address dropdown
        const anyAddress = { customer_id: null, shipping_contact_id: null, first_name: "Any Address" };
        $ctrl.addresses = [anyAddress];
        $ctrl.selectedAddress = anyAddress;
        $ctrl.addressSelected = address => {
            $ctrl.selectedAddress = address;
            $ctrl.orders.searchCriteria.shipping_contact_id = address.shipping_contact_id;
        };

        const dateFilter = $filter('date');
        $ctrl.addressDateRange = () => {
            if (!$ctrl.orders.searchCriteria.order_from_date || !$ctrl.orders.searchCriteria.order_to_date)
                return "";
            else
                return `used between ${dateFilter($ctrl.orders.searchCriteria.order_from_date, 'MM/dd/yyyy')} and ${dateFilter($ctrl.orders.searchCriteria.order_to_date, 'MM/dd/yyyy')}`;
        }

        // products dropdown
        $ctrl.products = [];
        $ctrl.selectedProduct = null;
        $ctrl.productSelected = product => {
            $ctrl.selectedProduct = product;
            $ctrl.orders.searchCriteria.item_id = product ? product.item_id : null;
        };
        $ctrl.isProductSearchTextValid = () => {
            // When a product is selected, $ctrl.productSearchText will be the object selected,
            // otherwise it will just be a string of whatever the user has typed.
            // It is valid if nothing is selected, or a product object is selected
            return $ctrl.productSearchText == null || $ctrl.productSearchText.length === 0 || typeof $ctrl.productSearchText === "object";
        };

        // handle date changes
        $scope.$watchCollection(() => ({
            order_from_date: $ctrl.orders.searchCriteria.order_from_date,
            order_to_date: $ctrl.orders.searchCriteria.order_to_date
        }),
            (newDates, oldDates) => {
                if (newDates === oldDates) return;
                if (moment(newDates.order_from_date).isSame(oldDates.order_from_date) && moment(newDates.order_to_date).isSame(oldDates.order_to_date)) return;

                if (newDates.order_from_date && newDates.order_to_date)
                    loadAddressesForSelectedCustomer();
            });

        // order status dropdown
        $ctrl.orderStatuses = [{ OrderStatus: null, Description: "Any" }];

        $ctrl.$onInit = () => {
            $q.all([
                lookups.getOrderStatuses(),
                loadAddressesForSelectedCustomer(),
                loadProductsForSelectedCustomer()
            ])
                .then(([orderStatuses]) => {
                    $ctrl.orderStatuses = $ctrl.orderStatuses.concat(orderStatuses);
                    if (!$ctrl.orders.hasSearched)
                        $ctrl.clear();
                    $ctrl.search();
                })
                .catch(toast.errorHandler);
        };

        function loadAddressesForSelectedCustomer() {
            $ctrl.ui.busy.addresses = true;
            return session.addresses.getShippingByOrderDate(
                $ctrl.orders.searchCriteria.customer_id,
                $ctrl.orders.searchCriteria.order_from_date,
                $ctrl.orders.searchCriteria.order_to_date)
                .then(addresses => {
                    $ctrl.addresses = [anyAddress].concat(addresses);
                    $ctrl.addressSelected($ctrl.addresses.find(a => a.shipping_contact_id === $ctrl.orders.searchCriteria.shipping_contact_id) || anyAddress);
                })
                .finally(() => { $ctrl.ui.busy.addresses = false; });
        }

        function loadProductsForSelectedCustomer() {
            $ctrl.ui.busy.products = true;
            return session.products.getForCustomer($ctrl.orders.searchCriteria.customer_id)
                .then(products => {
                    $ctrl.products = products;
                    $ctrl.productSelected(products.find(p => p.item_id === $ctrl.orders.searchCriteria.item_id));
                    $ctrl.productSearchText = $ctrl.selectedProduct;
                })
                .finally(() => { $ctrl.ui.busy.products = false; });
        }

        $ctrl.canSearch = () => $ctrl.orders.canSearch() && $ctrl.form.$valid;

        $ctrl.search = () => {
            $ctrl.ui.busy.search = true;
            $ctrl.orders.search()
                .catch(toast.errorHandler)
                .finally(() => { $ctrl.ui.busy.search = false; });
        };

        $ctrl.clear = () => {
            $ctrl.orders.clear();
            $ctrl.customerSelected(session.customer).then(() => {
                $ctrl.selectedAddress = $ctrl.addresses[0];
                $ctrl.productSelected(undefined);
                $ctrl.productSearchText = undefined;
            });
        };

        $ctrl.getExport = () => {
            $analytics.eventTrack("Click", { category: "Export", label: "Orders", value: $ctrl.orders.searchResults.length });
            return $ctrl.orders.searchResults.map(order => ({
                "Customer": order.company_name,
                "Customer Order Number": order.customer_order_no,
                "Order Id": order.order_id,
                "Order Date": order.order_date,
                "Status": order.status_description,
                "Ship To": `${order.ship_first_name} ${order.ship_last_name}`,
                "Address": `${order.ship_address1 || ''}`,
                "Address 2": `${order.ship_address2 || ''}`,
                "City": `${order.city_name || ''}`,
                "State": `${order.state_code || ''}`,
                "Zip": `${order.zip_code || ''}`,
                "Order Name": order.order_name,
                "Total": order.order_total
            }));
        };

        // format address in grid
        $ctrl.formatAddress = order => {
            return `${order.ship_first_name} ${order.ship_last_name}<br>` +
                `${order.ship_address1}<br>` +
                (order.ship_address2 ? `${order.ship_address2}<br>` : '') +
                `${order.city_name || ''}${order.city_name && ', ' || ''}${order.state_code || ''} ${order.zip_code || ''}`;
        };

        $ctrl.reorderClicked = (orderId) => {
            //$window.ga("send", "event", "Reorder", "orderListReorderClicked");
            $analytics.eventTrack("Click", { category: "Reorder", label: "Order History", value: `${orderId}` });
            $location.path(`/purchase-order/${orderId}`);
        };

        //DATEPICKER FUNCTION
        $ctrl.toggles = {};
        $ctrl.toggleDatePicker = datePicker => {
            $ctrl.toggles[datePicker] = !$ctrl.toggles[datePicker];
        };
        const tenYearsAgo = new Date();
        tenYearsAgo.setYear(tenYearsAgo.getFullYear() - 10);

        $ctrl.datePickerOptions = {
            "show-weeks": false,
            timezone: "utc",
            minDate: tenYearsAgo
        };
    }
    controller.$inject = ["$window", "$location", "$scope", "$q", "$filter", "$analytics", "ordersService", "lookupsService", "sessionService", "stToastFactory"];

})()